import { localStorageUtil } from '../../utils/local-storage.util';

export const sidebarStateStorage = localStorageUtil<boolean>('fullSidebar');
